export default __webpack_public_path__ + "static/media/Hammer of the Void.8a4eef3c.jpg";